import React from 'react';

const reviews = [
  {
    name: "Person with an Invisible Disability",
    image: "/Assets/Images/women.svg", // Using hero.png as a placeholder
    text: `"The sunflower lanyard was a beautiful way to affirm my differences as well as to celebrate them. As a Queer person with ADHD, I do not fully relate to just a pride rainbow representation often. Here though when I received the sunflower lanyard at the purple fest when everyone owned up their differences, it was a great way for me to show my invisible disability in a simple and effective manner allowing others to not consider me as a caregiver or an ally. Thank you team Chronic Pain India for such a unique and effective solution."`,
  },
  {
    name: "Parent of a Child with a Rare Disease",
    image: "/Assets/Images/man.svg", // Using hero.png as a placeholder
    text: `"The lanyard was a great initiative, easily visible to everyone, accessible for Persons with low vision. The bright yellow sunflower draws everyone's attention and is very helpful as I wore it at different instances and got noticed and supported. It facilitates easy understanding and acceptance in any environment, is my observation."`,
  },
];

const ReviewSection = () => {
  return (
    <section className="bg-[#F5F0FA] w-full md:px-20 px-4 py-10">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between w-full gap-10">
        <h2 className="text-2xl font-bold mb-4">
          <span className="pb-1 inline-block text-[#118B91]">Hear what people are saying</span>
        </h2>

        {reviews.map((item, idx) => {
          return (
            <div key={idx} className="flex flex-col md:w-1/2">
              <div className="flex items-start gap-4">
                <img
                  src={item.image}
                  alt={idx === 0 ? 'Illustrated avatar of a person with short dark hair inside a purple circle, next to the testimonial.' : 'Illustrated avatar of a man with glasses and a beard inside a purple circle, next to the testimonial.'}
                  className="rounded-full object-cover mt-1 w-[56px] h-[56px] bg-[#753ABF]"
                />
                <div>
                  <p className="text-sm text-black mb-2 italic">
                    {item.text}
                  </p>
                  <div className="mt-2">
                    <span className="font-bold text-black block">
                      {item.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ReviewSection;